var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.05263 4.71429V8.38095H2.63158V4.71429H1.05263ZM4.21053 4.71429V8.38095H5.78947V4.71429H4.21053ZM0 11H10V9.42857H0V11ZM7.36842 4.71429V8.38095H8.94737V4.71429H7.36842ZM5 0L0 2.61905V3.66667H10V2.61905L5 0Z",
    fill: "#8D8EA2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.1e8a65af70277bd0a1a143beff877f0a.svg";
export { ForwardRef as ReactComponent };